/**
 * Reads a runtime config value: `runtimeConfig.public[key]` first, then the server-only `runtimeConfig[key]`.
 * Never reads `process.env`, so a value only has its `NUXT_`/`NUXT_PUBLIC_` env name (see ENV_VARIABLES.md).
 * Returns `undefined` when the key is missing or runtime config is unavailable (outside Nuxt).
 */
export const getEnvironmental = (key: string): string | undefined => {

  try {

    const runtimeConfig = useRuntimeConfig();
    const fromPublic = runtimeConfig?.public?.[key];

    if (fromPublic !== undefined) {

      return fromPublic as string | undefined;

    }

    const fromPrivate = (runtimeConfig as Record<string, unknown>)?.[key];

    return fromPrivate as string | undefined;

  } catch (err) {

    console.warn(`[getEnvironmental] useRuntimeConfig() not available for "${key}":
      ${(err as Error)?.message}. Returning value: undefined`);

    return undefined;

  }

};
